import { InjectionToken } from '@angular/core';

export const PROVINCE_NAMES = new InjectionToken<Map<string, string> | undefined>(
  'Province names token'
);
